// extracted by mini-css-extract-plugin
module.exports = {"Container":"Human_Container__1pZvE","Scale":"Human_Scale__2B2ro","HumanHeightIndicator":"Human_HumanHeightIndicator__25o5G","Body":"Human_Body__3qEik"};